// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"436":"bbe6d55a","477":"6908b0bd","835":"e1eb4f2a","972":"1f6ee940"}[chunkId] + ".chunk.js");